export default class {
    static projectName = "Apprenticeship";
    static userData = "USER_DATA";
    static themeColor = '#222751';


    static emailRjx = /\S+@\S+\.\S+/;
}